import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { addNegativeToast } from 'modules/toastContainer';
import { useQueryLocalesSettings } from '../../hooks/useQueryLocalesSettings';
import { LocaleSettingsContext, LocaleSettingsContextState } from './LocaleSettingsContext';

const GET_LOCALES_ERROR =
  'Unable to fetch locales. Please try again, or contact your account manager.';

export const LocaleSettingsContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const dispatch = useDispatch();

  const {
    isLoading,
    invalidWhatsAppLocales,
    validWhatsAppLocales,
    refetch,
    locales,
    isTemplateDefaultLocaleModifiable,
  } = useQueryLocalesSettings({
    onError: () => {
      dispatch(addNegativeToast(GET_LOCALES_ERROR));
    },
  });

  const hasLocales = locales.length > 0;

  const context: LocaleSettingsContextState = {
    hasLocales,
    isLoading,
    locales,
    invalidWhatsAppLocales,
    validWhatsAppLocales,
    isTemplateDefaultLocaleModifiable,
    refetch,
  };

  return (
    <LocaleSettingsContext.Provider value={context}>{children}</LocaleSettingsContext.Provider>
  );
};
